// redux/getCartCountSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCartCountService } from "../services/addToCartServices";

// Async thunk to get cart count
export const getCartCount = createAsyncThunk(
  "cartcount/getCartCount",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCartCountService();
      return response.data.total; // Return the total count from the response
    } catch (error) {
      return rejectWithValue(error.message); // In case of error, return the error message
    }
  }
);

const initialState = {
  cartcount: 0, // Initial count is 0
  loading: false,
  error: null,
};

const getCartCountSlice = createSlice({
  name: "cartcount",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCartCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCartCount.fulfilled, (state, action) => {
        state.loading = false;
        state.cartcount = action.payload; // Set the count with the response from the service
      })
      .addCase(getCartCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Set the error message
      });
  },
});

export default getCartCountSlice.reducer;
